import { faFile } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { TempoSyncPreview } from '~/api/queries/order'
import {
  previewDocumentItem,
  previewDocuments,
  previewDocumentsTitle,
  previewDocumentType,
  previewField,
  previewFieldLabel,
  previewFieldValue,
  previewGrid,
  previewTitle,
  previewWrapper
} from './TempoSyncPreviewSection.css'

type Props = {
  preview: TempoSyncPreview
}

export const TempoSyncPreviewSection = ({ preview }: Props) => (
  <div className={previewWrapper}>
    <div className={previewTitle}>Données envoyées à Tempo :</div>
    <div className={previewGrid}>
      {preview.fields.map((field) => (
        <div key={field.label} className={previewField}>
          <span className={previewFieldLabel}>{field.label} :</span>
          <span className={previewFieldValue} title={field.value}>
            {field.value}
          </span>
        </div>
      ))}
    </div>
    {preview.documents.length > 0 && (
      <div className={previewDocuments}>
        <div className={previewDocumentsTitle}>Documents :</div>
        {preview.documents.map((doc) => (
          <div
            key={`${doc.typeName}-${doc.filename}`}
            className={previewDocumentItem}
          >
            <FontAwesomeIcon icon={faFile} />
            <span className={previewDocumentType}>{doc.typeName} :</span>
            <span>{doc.filename}</span>
          </div>
        ))}
      </div>
    )}
  </div>
)
